import React, { useState, useEffect, useRef } from "react";
import moment from 'moment'
import SvgWave from "./svgWave.jsx";
import HeartRateDraw from "./HeartRateDraw.jsx";
import { useTranslation } from "react-i18next";
import Loading from "../../Loading.jsx";
import { useRecoilState } from "recoil";
import { trendZoomState, selectBedInfoState, isFromSearchState } from "../../../plugins/recoil";
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';
import {ReactComponent as IconRight} from '../../../assets/icons/ic-calendar-right.svg'
import {ReactComponent as IconLeft} from '../../../assets/icons/ic-calendar-left.svg'
 
const Index = ({waveStartDate,waveEndTime,zoomTime,trendData,isTrendFull,isTrendClose,handleChangeTime,trendWaveType,handleChangeWaveType,handleSelectBoxTimeInfo,selectBoxTimeInfo,handleLoading,timeSettings,loading,handleDoubleClick,patientHistories,canSearchMoves}) => {
    const { t } = useTranslation()
    const selectRef = useRef();
    const containerRef = useRef(); //부모 Ref 
    const [trendZoom, ] = useRecoilState(trendZoomState);    
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState);
    const [isFromSearch, ] = useRecoilState(isFromSearchState)
    const [waveData, setWaveData] = useState();
    const [hrData, setHrData] = useState();
    const [boxInfo, setBoxInfo] = useState();
    const [isHrValueChecked, setIsHrValueChecked] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false) //SelectBox
    const [patientDischargeMarker, setPatientDischargeMarker] = useState(null)

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    const leadType = ['LEADⅠ','LEADⅡ','LEADⅢ'];
    const leadTypeText = {
        'LEADⅠ': 'LEADⅠ',
        'LEADⅡ': 'LEADⅡ',
        'LEADⅢ': 'LEADⅢ'
    }
    
    const selectBoxStyle = "border-[1px] border-[#fff] border-dotted bg-[#fff] bg-opacity-20 ";
    const defaultBoxStyle = "border-[1px] border-[#2F2F2F] border-box hover:border-dotted hover:border-[1px] hover:border-[#fff]";    
    
    // Wave 박스 정보 설정 (가로 세로 크기 등등)
    const setWaveBoxInfo = () => {
        const containerRect = containerRef.current.getBoundingClientRect();        
        let width = (containerRect.width - 4) / timeSettings[trendZoom]["columns"];
        let height = 30; 

        setBoxInfo({
            fullWidth : containerRect.width,
            width : width,
            height : height,
            columns : timeSettings[trendZoom]["columns"],            
            strokeWidth: 0.75,
            strokeColor: "#9F9F9F",
            yOffset: timeSettings[trendZoom]["yOffset"], //웨이브 시작 지점 위치 변경
        });     

        const wave = setSplitData(trendData.Wave, 30);
        setWaveData(wave);

        const hr = setSplitData(trendData.HeartRate, 30);        
        setHrData(hr);

        if(isHrValueChecked){
            if(trendData.HeartRate.length > 0){                                                
                handleSelectBoxTimeInfo(hr[hr.length-1][0].timestamp);
            }
        }else {
            if(trendData.Wave.length > 0){                                                
                handleSelectBoxTimeInfo(wave[wave.length-1][0].createdAt);                
            }
        }
    }

    //데이터 30개씩 나누기
    const setSplitData = (data, batchSize) => {
        if(!data) return [];
        const result = [];
        let batch = [];
    
        for (let i = 0; i < data.length; i++) {
            batch.push(data[i]);
            if (batch.length === batchSize || i === data.length - 1) {
                result.push(batch);
                batch = [];
            }
        }
    
        return result;
    }
    
    const getPatientDischargeMarker = () => {
        if (!patientHistories || !Array.isArray(patientHistories)) {
            setPatientDischargeMarker([]);
            return;
        }

        // 1. waveStartDate ~ waveEndTime 범위의 ADDMITTIED, UNASSIGNED 데이터만 추출
        const startTime = moment(waveStartDate);
        const endTime = moment(waveEndTime);

        const filtered = patientHistories            
            .filter(h => {
                const t = moment(h.createdAt);
                return t.isValid() && t.isSameOrAfter(startTime) && t.isSameOrBefore(endTime);
            });

        // 2. createdAt 포맷 변환 ("2025-08-20T15:19:47+09:00" 형태)
        const markers = filtered.map(h => ({
            ...h,
            formattedTime: moment(h.createdAt).format("YYYY-MM-DDTHH:mm:ssZ")
        }));

        // 3. 마커 세팅
        setPatientDischargeMarker(markers);
    };

    useEffect(() => {
        if (trendData) {    
            setWaveBoxInfo();
            getPatientDischargeMarker();
            handleLoading(false);
        }
    }, [trendData]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const nextDisabled = moment(waveEndTime).add(zoomTime, 'seconds').isAfter(moment());    

    return (
        <div className={`${loading ? 'h-full' : '' } w-full flex flex-col justify-between flex-1`} >
            <div className="relative flex flex-nowrap justify-between w-full h-[36px] px-[8px]">
                <div className="relative my-[5px]" ref={selectRef}>                            
                    <div className="bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#DEDEDE] w-[130px] h-[26px] py-[5px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]" onClick={(e) => { e.stopPropagation(); setIsDropdownOpen((prev) => !prev);}}>                                
                        <div className="w-[200px]">ECG {trendWaveType}</div>
                    </div>
                    {
                        isDropdownOpen && (
                            <div className="absolute top-[30px] bg-[#1F1F1F] w-[130px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">
                                {
                                    leadType.map((lead,_) => (
                                        <div className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${trendWaveType === lead ? "text-[#3182F7]" : "text-white"}`} 
                                             onClick={(e) => { e.stopPropagation(); handleChangeWaveType(lead); (trendWaveType != lead && setIsDropdownOpen((prev) => !prev))}}
                                             key={_}
                                        >
                                            {leadTypeText[lead]}
                                            {trendWaveType === lead && (
                                                <IconCheck className="w-4 h-4 ml-2" />
                                            )}
                                        </div>
                                    ))
                                }                                       
                            </div>
                        )
                    }
                    <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                        {isDropdownOpen ?  <IconArrowUp/> : <IconArrowDown/>}
                    </div>
                </div>                
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                    <div className="flex justify-center items-center w-[72px] h-[26px] mx-auto mt-2 mb-2 bg-[#2C2C2C] rounded-[16px] border-[rgba(255,255,255,0.1)]">
                        <div className="flex items-center px-2 py-[4px] cursor-pointer" onClick={isFromSearch ? (canSearchMoves.trendPrev ? () => handleChangeTime('prev') : null) : () => handleChangeTime('prev')} style={{ opacity: isFromSearch ? (canSearchMoves.trendPrev ? 1 : 0.3) : 1 }}>
                            <IconLeft />
                        </div>
                        <div className="flex items-center px-2 py-[4px] cursor-pointer" onClick={isFromSearch ? (canSearchMoves.trendNext ? () => handleChangeTime('next') : null) : (() => !nextDisabled ? handleChangeTime('next') : null)} style={{ opacity: isFromSearch ? (canSearchMoves.trendNext ? 1 : 0.3) : (nextDisabled ? 0.3 : 1) }}>
                            <IconRight />
                        </div>
                    </div>
                </div>
                <div className="flex justify-center items-center gap-[12px]">
                    <div className="flex items-center gap-[4px]">
                        <input
                            type="checkbox"
                            id="chkHR"
                            checked={isHrValueChecked}
                            onChange={(e) => setIsHrValueChecked(!isHrValueChecked)}
                        />
                        <label htmlFor="chkHR" className="cursor-pointer">
                            HR {t('trend.value')}
                        </label>                            
                    </div>
                    <div className="w-[1px] h-[24px] bg-[#444] py-[6px]"></div>
                    <div className="flex items-center mr-[20px]">
                        {trendZoom.replace('m','min')}
                    </div>
                </div>
            </div>         
            <div ref={containerRef} className="relative flex flex-wrap justify-center flex-1 w-full h-full overflow-hidden">
                {
                    isHrValueChecked ? hrData && hrData.length > 0 ? (
                        hrData.map((data,idx)=> ( 
                             <div className="relative" key={`trend-heartRate-container-${idx}`}>
                                <HeartRateDraw
                                    key={idx}
                                    data={data}
                                    boxInfo={boxInfo}
                                    style={ moment(data[0].timestamp).isSame(moment(selectBoxTimeInfo)) ? selectBoxStyle : defaultBoxStyle}
                                    handleSelectBoxTimeInfo={() => handleSelectBoxTimeInfo(data[0].timestamp)}                                    
                                    handleDoubleClick={handleDoubleClick}
                                    patientDischargeMarker={patientDischargeMarker}
                                />
                                {
                                    moment(data[0].timestamp).isSame(moment(selectBoxTimeInfo)) && (
                                        <div className={`absolute ${idx < 5 ? 'bottom-[-22px]' : 'top-[-21px]' } left-0 text-[#fff] bg-[rgba(0,0,0,0.6)]`}>
                                            {moment(data[0].timestamp).format('HH:mm:ss')}
                                        </div>
                                    )
                                }         
                            </div>                             
                        ))
                    ) : (
                        !loading && (                                    
                            <div className="absolute flex items-center justify-center w-full h-full">
                                {t('error.noDataAvailable')}
                            </div>
                        )
                    ) : waveData && 
                        waveData.map((data, idx) => {
                            return (
                                <div className="relative" key={`trend-svg-wave-container-${idx}`}>
                                    <SvgWave
                                        key={`trend-svg-wave-item-${idx}`}
                                        data={data}
                                        boxInfo={boxInfo}
                                        style={ moment(data[0].createdAt).isSame(moment(selectBoxTimeInfo)) ? selectBoxStyle : defaultBoxStyle }
                                        handleSelectBoxTimeInfo={() => handleSelectBoxTimeInfo(data[0].createdAt)}                                                           
                                        handleDoubleClick={handleDoubleClick}
                                        patientDischargeMarker={patientDischargeMarker}
                                    />
                                    {
                                        moment(data[0].createdAt).isSame(moment(selectBoxTimeInfo)) && (
                                            <div className={`absolute ${idx < 5 ? 'bottom-[-22px] z-10' : 'top-[-21px]' } left-0 text-[#fff] bg-[rgba(0,0,0,0.6)]`}>
                                                {moment(data[0].createdAt).format('HH:mm:ss')}
                                            </div>
                                        )
                                    }                                    
                                </div>
                            )
                        }
                    )
                }                
                <div className="absolute top-0 left-0 text-[#fff] px-[10px]">
                    {waveStartDate && moment(waveStartDate).format('YYYY-MM-DD HH:mm:ss')}
                </div>
                <div className="absolute bottom-0 right-0 text-[#fff] px-[10px]">
                    {waveStartDate && moment(waveStartDate).add(isTrendFull ? (isTrendClose ? 60 : 40) : 15, 'minutes').format('YYYY-MM-DD HH:mm:ss')}
                </div>
                {
                    loading && <Loading />
                }
            </div>
        </div>
    )
}

export default Index